import React, { useState, useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { getAsset } from "../../helpers/helper";
import { images } from "../../constants";
import Reportreplymodal from "../report_suggest_d-modal";
import url from "../../config/axios";
const Suggestionreply = ({ suggestdata }) => {
  const [lgShow, setLgShow] = useState(false);
  const [singledata, setSingledata] = useState("");

  const dataFetch = (s, r) => {
    url
      .get(`suggestion/get-reply?suggestionId=${r}&vendorId=${s}`)
      .then(async (res) => {
        setSingledata(res?.data);
      });
  };
  return (
    <>
      <Reportreplymodal
        setLgShow={setLgShow}
        lgShow={lgShow}
        singledata={singledata}
        title="Suggestion Reply"
      />
      <Container className="px-0">
        <div style={{ width: "100%" }} className="mt-2">
          <img
            src={images.Bannerimage}
            style={{ width: "100%", maxHeight: "150px", objectFit: "cover", borderRadius: "8px" }}
            alt="Banner"
          />
        </div>
        <div className="d-flex align-items-center mt-2 mb-4 px-2">
          <h4 className="mb-0 ms-3">Suggestion Reply</h4>
        </div>
        <div className="scrll noscroll">
          {suggestdata && suggestdata?.length > 0 ? (
            suggestdata?.map((e) => (
              <Row className="align-items-center">
                <Col className="mt-2" lg="1">
                  <img
                    className="ms-3 pi-ck"
                    src={getAsset(e?.suggestions?.replies[0]?.imageUrl[0])}
                    alt=""
                    crossOrigin="anonymous"
                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "50%" }}
                  />
                </Col>
                <Col className="mt-2" lg="9">
                  <h6 className="-size m-0">
                    Name: {e?.suggestions?.replies[0]?.role}
                  </h6>
                  <p className="PHERA-0 mb-0">
                    <spam style={{ fontWeight: "600" }}>ID:</spam> {e?.vendorId}
                  </p>
                  <p className="PHERA mb-0 mt-1">
                    {" "}
                    <spam style={{ fontWeight: "600" }}>Message:</spam>{" "}
                    {e?.suggestions?.replies[0]?.message?.length > 100
                      ? e?.suggestions?.replies[0]?.message.slice(0, 100) +
                        "..."
                      : e?.suggestions?.replies[0]?.message}
                  </p>
                </Col>
                <Col lg="2">
                  <div className=" d-flex">
                    <Col>
                      <button
                        type="button"
                        className="button-01 ms-4 mt-4"
                        onClick={() => {
                          dataFetch(e?.vendorId, e?.suggestions?._id);
                          setLgShow(true);
                        }}
                      >
                        Read
                      </button>
                    </Col>
                  </div>
                </Col>
                <hr />
              </Row>
            ))
          ) : (
            <div className="d-flex justify-content-center">
              <h5>No Data Found</h5>
            </div>
          )}
        </div>
      </Container>
    </>
  );
};
export default Suggestionreply;
